import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaAtenciones from './TablaAtenciones';

const Atenciones: React.FC = () => (
  <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
    <TablaAtenciones />
  </Box>
);

export default Atenciones;
